module.exports = __webpack_public_path__ + "img/whatsapp-color.d514df10.svg";